import { useQuery } from 'react-query';
import { languagesGqlQuery } from 'src/modules/user/graphql/languages.query';
import { APIs } from 'src/models/apis';
import { useAPIs } from 'src/hooks/useAPIs';
import { QueryKey } from 'src/models/query';

export const fetchLanguages = async (apis: APIs) => {
  const directus = await apis.directus();

  return directus.query(languagesGqlQuery).then((a) => a.languages);
};

export const useLanguagesQuery = () => {
  const apis = useAPIs();

  return useQuery(QueryKey.ProfileLanguages, () => fetchLanguages(apis), {
    refetchOnMount: false,
    keepPreviousData: true,
    refetchOnReconnect: false,
  });
};
